module.exports = __webpack_public_path__ + "static/media/food.d6656409.webp";